<template>
<v-content class="spinelab-website-front">
  <v-container v-if="initiated">
    <v-flex xs12 sm12 md12>
      <h1 class="text-sm-left">アドミンユーザ管理</h1>
    </v-flex>
    <template v-if="detail">
      <v-dialog v-model="dialog" max-width="500px">
        <v-card class="spinelab-website-front">
          <v-flex md10 offset-md1>
            <v-card-text>
              削除したユーザを元に戻すことはできません。本当に削除しますか。
            </v-card-text>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="cancelDialogue()">
              キャンセル
            </v-btn>
            <v-btn @click="confirmRemove()"
                   :loading="removing"
                   color="error">
              削除する
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn
        @click="backToList()"
        :loading="saving">
        一覧に戻る
      </v-btn>
      <v-layout v-for="column in editedItem"
                :key="column.label"
                row>
        <v-flex md3>
          <v-subheader>
            <p>{{column.label}}</p>
          </v-subheader>
        </v-flex>
        <v-flex md9 v-if="!column.editable">
          {{column.content}}
        </v-flex>
        <v-flex md9 v-else-if="column.editor === 'input-text'">
          <v-text-field
             v-model="column.content"
             :errorMessages="errorMessages[column.label] ?
 errorMessages[column.label].message : []">
          </v-text-field>
        </v-flex>
        <v-flex md9 v-else-if="column.editor === 'select-option'">
          <v-select
            :items="column.options"
            v-model="column.content"
            :errorMessages="errorMessages[column.label] ?
            errorMessages[column.label].message : []"
            single-line>
          </v-select>
        </v-flex>
      </v-layout>
      <v-btn
        color="error"
        v-if="editedId !== undefined"
        @click="remove()"
        :loading="saving">
        このユーザを削除する
      </v-btn>
      <v-btn
        color="success"
        @click="save()"
        :loading="saving">
        保存
      </v-btn>
    </template>
    <template v-else>
      <v-layout row>
        <v-btn color="primary" @click="showDetail()">
          新規アドミンユーザ登録
        </v-btn>
      </v-layout>
      <v-layout row>
        <v-spacer/>
        <v-btn icon @click="loadAdminUsers" :disabled="loading">
          <v-progress-circular :size="20" indeterminate v-if="loading">
          </v-progress-circular>
          <v-icon v-else>cached</v-icon>
        </v-btn>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="users"
        :total-items="totalItems"
        :pagination.sync="pagination"
        :loading="loading"
        rows-per-page-text="一度に表示するユーザ数"
        :rows-per-page-items="rowsPerPageItems"
        id="admin-admin-users-data-table"
        >
        <template slot="headers" slot-scope="props">
          <th v-for="header in headers"
              :key="header.value"
              :style="`text-align: ${header.align || 'left'};`">
            {{header.text}}
          </th>
        </template>
        <template slot="items" slot-scope="props">
          <td v-for="header in headers" :key="header.value">
            <a @click="showDetail(props.item)" v-if="header.value === 'detail'">
              詳細
            </a>
            <template v-else>
              {{props.item[header.value]}}
            </template>
          </td>
        </template>
        <template slot="pageText" slot-scope="props">
          {{ props.itemsLength }}件中{{ props.pageStart }} - {{ props.pageStop }}件
        </template>
      </v-data-table>
    </template>
  </v-container>
</v-content>
</template>

<script>
import { mapState, mapActions } from 'vuex';

const successUpdate = 'アドミンユーザ情報の変更を保存しました';
const successCreate = '新規アドミンユーザを登録しました';
const successRemove = 'アドミンユーザを削除しました';
const failUpdate = '変更された情報の保存時にエラーが発生しました';
const failCreate = 'アドミンユーザ登録時にエラーが発生しました';

export default {
  name: 'AdminUsers',
  data() {
    return {
      loading: false,
      uploading: false,
      downloading: false,
      saving: false,
      initiated: false,
      users: [],
      totalItems: 0,
      detail: false,
      editedItem: [],
      editedId: undefined,
      search: '',
      errorMessages: {},
      dialog: false,
      removing: false,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Login ID', value: 'login_id' },
        { text: '名前', value: 'name' },
        { text: '', value: 'detail', sortable: false },
      ],
      rowsPerPageItems: [50, 100],
      pagination: {},
    };
  },
  computed: {
    ...mapState({
      requests: state => state.requests,
    }),
    formTitle() {
      return this.editedItem.length === 0 ? '新規アドミンユーザ登録' : 'アドミンユーザ情報編集';
    },
    castPagination() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      return {
        order: sortBy || 'id',
        isDesc: descending || false,
        page: page || 1,
        perPage: rowsPerPage || this.rowsPerPageItems[0],
      };
    },
  },
  watch: {
    pagination: {
      deep: true,
      handler() {
        this.loadAdminUsers();
      },
    },
  },
  methods: {
    ...mapActions(['showAlert', 'setSite']),
    backToList() {
      this.errorMessages = [];
      this.detail = false;
    },
    async remove() {
      this.errorMessages = [];
      this.removing = false;
      this.dialog = true;
    },
    async cancelDialogue() {
      this.dialog = false;
    },
    async confirmRemove() {
      this.removing = true;
      const result = await this.requests.deleteAdminUser(this.editedId);
      if (!result) {
        this.showAlert({ message: undefined, type: 'error' });
      } else {
        this.showAlert({ message: successRemove, type: 'success' });
      }
      this.dialog = false;
      this.detail = false;
    },
    async save() {
      this.saving = true;
      this.errorMessages = [];
      const result = await this.requests.postAdminUserDetail(
        this.editedId, { user_informations: this.editedItem });
      if (result === undefined) {
        this.showAlert({ message: undefined, type: 'error' });
      } else if (result.isError) {
        this.errorMessages = result.data;
        this.showAlert({
          message: this.editedId === undefined ? failCreate : failUpdate,
          type: 'error',
        });
        this.saving = false;
        return;
      } else {
        this.showAlert({
          message: this.editedId === undefined ? successCreate : successUpdate,
          type: 'success',
        });
      }
      this.saving = false;
      this.detail = false;
    },
    async loadAdminUsers() {
      this.loading = true;
      const result = await this.requests.getAdminUsers(
        this.castPagination, this.search);
      if (result && 'data' in result && 'total' in result) {
        this.users = result.data;
        this.totalItems = result.total;
      }
      this.loading = false;
    },
    async showDetail(item) {
      if (item) {
        this.editedId = item.id;
        this.editedItem = await this.requests.getAdminUserDetail(item.id);
      } else {
        this.editedId = undefined;
        this.editedItem = await this.requests.getAdminUserDetail();
      }
      this.errorMessages = [];
      this.detail = true;
    },
  },
  async created() {
    await this.loadAdminUsers();
    this.initiated = true;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminUsers.vue